import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { connect } from 'react-redux';
import AssignTags from '../../assets/TableIcon/assign-tags.svg';
import DeleteTags from '../../assets/TableIcon/delete-tags.svg';
import RemoveTags from '../../assets/TableIcon/remove-tags.svg';
import ElfoLogoCool from '../../assets/elfo-logo-cool.svg';
import ContactAssignTags from './ContactAssignTags';
import ContactDelete from './ContactDelete';
import ContactDetails from './ContactDetails';
import ContactRemoveTags from './ContactRemoveTags';

const ContactTables = ({ allTags, contactData, setContactData, setLeadListId }) => {
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalTagsShow, setTagsShow] = useState(false);
  const [modalRemoveTagsShow, setRemoveTagsShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowTags, setSelectedRowTags] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [contactDetailData, setContactDetailData] = useState({});

  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [stateFormContact, setStateFormContact] = useState('add');

  const prevDataRef = useRef(contactData);

  const [isActive, setIsActive] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  const handleModalDetailOpen = data => {
    setModalDetailShow(true);
    setContactDetailData(data);
  };

  const handleModalAssignTagsOpen = () => {
    setTagsShow(true);
  };

  const handleModalRemoveTagsOpen = () => {
    setRemoveTagsShow(true);
  };

  const handleModelDeleteOpen = () => {
    setModalDeleteShow(true);
  };

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows || []);

    var temp_tags = [];
    state.selectedRows.map(item => temp_tags.push(...item.tags));
    setSelectedRowTags([...new Set(temp_tags)]);
  }, []);

  const handleDeleteConfirmClose = () => {
    setDeleteConfirm(false);
  };

  const createDynamicColumns = () => {
    // Get all unique keys from the meta object in contactData
    const metaKeys = Array.from(
      new Set(contactData?.flatMap(data => Object.keys(data.custom_field || {})))
    );
    // Dynamically create columns for each unique key in meta
    const dynamicColumns = metaKeys.map(key => ({
      name: key,
      sortable: false,
      selector: row => (row.custom_field ? row.custom_field[key] : null),
    }));
    return dynamicColumns;
  };

  const contextActions = useMemo(() => {
    return (
      <>
        <Button variant="link" onClick={() => handleModalAssignTagsOpen()}>
          <img src={AssignTags} style={{ width: '14px' }}></img>Assign Tags
        </Button>
        <Button variant="link" onClick={() => handleModalRemoveTagsOpen()}>
          <img src={RemoveTags} style={{ width: '14px' }}></img>Remove Tags
        </Button>
        <Button variant="link" onClick={() => handleModelDeleteOpen()}>
          <img src={DeleteTags} style={{ width: '14px' }}></img>Delete
        </Button>
      </>
    );
  }, [contactData, selectedRows, toggleCleared]);

  const handleRowClicked = row => {
    handleModalDetailOpen(row);
  };

  const handleToggleOpen = (state, row) => {
    setIsActive(state);
    if (state) {
      setActiveRow(row.id);
    } else {
      setActiveRow(null);
    }
  }

  const conditionalRowStyles = [
    {
      when: (row) => isActive && activeRow && activeRow === row.id,
      style: {
        zIndex: '999 !important'
      }
    }
  ];

  useEffect(() => {
    if (prevDataRef.current !== contactData) {
      setSelectedRows([]);
      setToggleCleared(!toggleCleared);
    }
    prevDataRef.current = contactData;
  }, [contactData])

  const columns = [
    {
      name: 'Mobile Number',
      sortable: true,
      id: 'fixed-left',
      minWidth: '180px',
      selector: row => row.phone,
    },
    {
      name: 'Tags',
      minWidth: '150px',
      selector: row => {
        if (row.tags.length >= 1) {
          return (
            <span
              title={row.tags.join(', ')}
              style={{
                display: 'block',
                width: 'calc(150px - 32px)',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {row.tags.join(', ')}
            </span>
          );
        } else {
          return 'N/A';
        }
      },
    },
    {
      name: 'Country',
      sortable: true,
      selector: row => row.country,
    },
    {
      name: 'Date Added',
      sortable: true,
      selector: row => row.date,
    },
    // dynamic columns here
    ...createDynamicColumns(),
    {
      name: 'Actions',
      sortable: false,
      center: 'true',
      id: 'fixed-right',
      width: '100px',
      selector: row => (
        <div>
          <Dropdown onToggle={(state) => handleToggleOpen(state, row)}>
            <Dropdown.Toggle variant="link" id="dropdown-table">
              <i className="fas fa-ellipsis-v" />
            </Dropdown.Toggle>

            <Dropdown.Menu align="right">
              <Dropdown.Item
                onClick={() => {
                  setStateFormContact('edit');
                  handleModalDetailOpen(row);
                }}
              >
                Edit
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <>
      {contactData.length > 0 ? (
        <DataTable
          title="&nbsp;"
          columns={columns}
          data={contactData}
          className="custom-datatable"
          selectableRows
          contextActions={contextActions}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          paginationComponentOptions={{
            rowsPerPageText: 'Items per page:',
          }}
          pagination
          onRowDoubleClicked={handleRowClicked}
          conditionalRowStyles={conditionalRowStyles}
        />
      ) : (
        <div id='no-contect-contact'>
          <img src={ElfoLogoCool} style={{ width: '200px' }}></img>
          <h3>Manage Your Contact</h3>
          <p>Create a new contact list or choose an existing one to manage your contacts efficiently.</p>
        </div>
      )
      }

      <ContactDetails
        modalDetailShow={modalDetailShow}
        setModalDetailShow={setModalDetailShow}
        data={contactDetailData}
        allData={contactData}
        setData={setContactData}
        allTags={allTags}
      />

      <ContactAssignTags
        modalTagsShow={modalTagsShow}
        setTagsShow={setTagsShow}
        allTags={allTags}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        setLeadListId={setLeadListId}
      />

      <ContactRemoveTags
        modalRemoveTagsShow={modalRemoveTagsShow}
        setRemoveTagsShow={setRemoveTagsShow}
        allTags={allTags}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        setLeadListId={setLeadListId}
        selectedRowTags={selectedRowTags}
      />

      <ContactDelete
        modalDeleteShow={modalDeleteShow}
        setModalDeleteShow={setModalDeleteShow}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
    </>
  );
};
const mapStateToProps = state => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ContactTables);
